// @ts-nocheck
import { Helmet } from 'react-helmet-async';
import VuiBreadcrumb from '../../../../vodea/@vodea-ui/components/VuiBreadcrumb';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import { useState } from '@hookstate/core/dist';
import { $clone, defaultActionFormatter } from '../../../../vodea/utilities';
import { Link, useLocation } from 'react-router-dom';
import VuiDateRangePicker from '../../../../vodea/@vodea-ui/components/Forms/VuiDateRangePicker';
import { useTranslation } from 'react-i18next';
import useIsMounted from '../../../../vodea/utilities/hooks/useIsMounted';
import GoodsReceiptRepository from '../../../../repositories/GoodsReceiptRepository';
import { AxiosError, AxiosResponse } from 'axios';
import { showToast } from '../../../../vodea/utilities/helpers/global';
import moment from 'moment';
import _ from 'lodash';
import VuiSelect from '../../../../vodea/@vodea-ui/components/Forms/VuiSelect';
import SupplierRepository from '../../../../repositories/SupplierRepository';
import VuiActionModal from '../../../../vodea/@vodea-ui/components/Modal/VuiActionModal';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../stores';
import useScroll from '../../../../vodea/utilities/hooks/useScroll';
import DataTableInfiniteScroll, { ITableColumn } from '../../../../vodea/@vodea-ui/components/DataTableInfiniteScroll';
import VuiSearch from '../../../../vodea/@vodea-ui/components/VuiSearch';
import VuiNumberFormat from '../../../../vodea/@vodea-ui/components/VuiNumberFormat';

const defaultStatusOptions = [
  { id: '1', name: 'Paid' },
  { id: '0', name: 'Unpaid' }
];

const PurchaseReceiveItem: React.FC<any> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isMounted = useIsMounted();
  const permissions = useSelector((state: RootState) => state.permission.permission.permissions);
  const tableDeleteId = useState(0);
  const showActionModal = useState(false);
  const { isBottom } = useScroll();
  const [hasMore, setHasMore] = React.useState<boolean>(false);
  const [isFetchingMoreData, setIsFetchingMoreData] = React.useState<boolean>(false);
  const [hasInitialize, setHasInitialize] = React.useState<boolean>(false);
  const [totalData, setTotalData] = React.useState<number>(0);

  const tableOnClickDelete = (id: number) => {
    tableDeleteId.set(id);
    showActionModal.set(true);
  };

  const tableHandleOnContinue = (e: React.MouseEvent) => {
    GoodsReceiptRepository.delete(tableDeleteId.get())
      .then((response: AxiosResponse) => {
        showToast(response.data.message, response.data.success ? 'success' : 'error');
        showActionModal.set(false);
        getTableData(true);
      })
      .catch((e: AxiosError) => {
        showToast(e.message, 'error');
      });
  };

  const title = t('Receive Item');

  const selectedSupplier = useState(null);
  const selectedStatus = useState(null);

  const tableConfig = useState({
    search: '',
    page: 1,
    per_page: 10,
    sorted_by: 'desc',
    order_by: 'date',
    total: 0,
    loading: false,

    // additional
    supplier: '',
    paid: '',

    date_from: moment().format('YYYY-MM-DD'),
    date_to: moment().format('YYYY-MM-DD')
  });

  const tableData = useState<any[]>([]);

  const tableColumns: ITableColumn[] = [
    {
      dataField: 'number',
      text: 'Number'
    },
    {
      dataField: 'purchase_order_number',
      text: 'PO Number',
      render: (cell: any, row: any) => {
        return (
          <Link color="blue" to={`/purchase/purchase-order/${row.purchase_order_id}`}>
            {cell}
          </Link>
        );
      }
    },
    {
      dataField: 'supplier_name',
      text: 'Supplier'
    },
    {
      dataField: 'date',
      text: 'Date',
      render: (cell: any) => {
        return moment(cell).format('D MMMM YYYY hh:mm A');
      }
    },
    {
      dataField: 'creator_name',
      text: 'Receiver'
    },
    {
      dataField: 'amount',
      text: 'Total',
      render: (cell: any) => {
        return <VuiNumberFormat data={cell} prefix={'IDR '} />;
      }
    },
    {
      dataField: 'status',
      text: 'Status',
      render: (cell: any) => {
        return cell?.toUpperCase();
      }
    },
    {
      dataField: 'action',
      text: 'Action',
      render: defaultActionFormatter,
      formatExtraData: {
        location: location.pathname,
        actionDelete: tableOnClickDelete,
        permission: 'goods-receipt',
        permissions: permissions
      }
    }
  ];

  const changeTableLoading = (val: boolean) => {
    if (isMounted.current) {
      tableConfig.loading.set(val);
    }
  };

  const getTableData = async (reset: boolean = false, forNextPage: boolean = false) => {
    if (reset) tableConfig.page.set(1);
    if (isMounted.current && forNextPage) {
      setIsFetchingMoreData(true);
      tableConfig.page.set(tableConfig.page.get() + 1);
    } else {
      changeTableLoading(true);
    }

    if (isMounted.current) {
      setHasMore(true);
    }

    const conf = _.omit($clone(tableConfig.value), 'loading');

    let params: any = {};
    Object.keys(conf).forEach(prop => {
      if (conf[prop]) {
        params[prop] = conf[prop];
      }
    });

    if (isMounted.current && !forNextPage) tableData.set([]);

    await GoodsReceiptRepository.all(params)
      .then((response: AxiosResponse) => {
        if (isMounted.current) {
          const { data: responseData } = response.data;
          tableData.merge(responseData);
          setIsFetchingMoreData(false);
          setHasInitialize(true);
          if (responseData.length == 0 || responseData.length < tableConfig.per_page.get()) {
            setHasMore(false);
          }
          if (reset) setTotalData(response.data.total_data);
        }

        changeTableLoading(false);
      })
      .catch((e: AxiosError) => {
        if (e.isAxiosError) showToast(e.message, 'error');
        if (isMounted.current) {
          setHasInitialize(true);
          setIsFetchingMoreData(false);
          setTotalData(0);
        }
        changeTableLoading(false);
      });
  };

  const handleTableDateRange = (start: any, end: any) => {
    tableConfig.date_from.set(start.format('YYYY-MM-DD'));
    tableConfig.date_to.set(end.format('YYYY-MM-DD'));

    getTableData(true);
  };

  useMemo(() => {
    getTableData(true);
  }, []);

  useMemo(() => {
    if (isBottom && hasInitialize && !isFetchingMoreData && hasMore) {
      getTableData(false, true);
    }
  }, [isBottom]);

  const handleTableSearch = (value: string) => {
    if (isMounted.current) {
      tableConfig.search.set(value);
      getTableData(true);
    }
  };

  const breadcrumbList = [
    {
      label: t('Purchase'),
      link: '/purchase'
    },
    {
      label: t('Receive Item'),
      link: '/purchase/receive-item'
    }
  ];

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <VuiBreadcrumb list={breadcrumbList} />

      <div className={'page-header-component'}>
        <h3 className={'title'}>{title}</h3>
        {permissions.includes('goods-receipt.store') ? (
          <div className={'btn-wrapper'}>
            <Link to={'/purchase/receive-item/create'}>
              <button type={'button'} className={'btn btn-primary'}>
                <FontAwesomeIcon className={'icon icon-prefix'} icon={faPlus} />
                {t('Create Receive Item')}
              </button>
            </Link>
          </div>
        ) : null}
      </div>

      {permissions.includes('goods-receipt.show') ? (
        <div className={'card-paper'}>
          <div className={'card-content'}>
            <div className={'default-filter-section'}>
              <div className={'filter-item filter-special type-search'}>
                <VuiSearch value={tableConfig.search.get()} callback={handleTableSearch} />
              </div>

              <div className={'filter-item filter-special'}>
                <VuiDateRangePicker
                  startDate={tableConfig.date_from.get()}
                  endDate={tableConfig.date_to.get()}
                  callback={handleTableDateRange}
                  useRanges={true}
                />
              </div>

              <div className={'filter-item'}>
                <div className='form-select-wrapper'>
                  <VuiSelect
                    placeholder={'Select Supplier'}
                    clearable={true}
                    selectRepository={SupplierRepository}
                    defaultValue={selectedSupplier.get()}
                    onChange={val => {
                      selectedSupplier.set(val);
                      tableConfig.supplier.set(_.get(val, 'id', null));
                      getTableData(true);
                    }}
                    isMulti={false}
                  />
                </div>
              </div>

              <div className={'filter-item'}>
                <div className='form-select-wrapper'>
                  <VuiSelect
                    placeholder={'Select Status'}
                    clearable={true}
                    options={defaultStatusOptions}
                    defaultValue={selectedStatus.get()}
                    onChange={val => {
                      selectedStatus.set(val);
                      tableConfig.paid.set(_.get(val, 'id', null));
                      getTableData(true);
                    }}
                    isMulti={false}
                  />
                </div>
              </div>
            </div>

            <DataTableInfiniteScroll
              columns={tableColumns}
              data={tableData.get()}
              propKey={'id'}
              isLoading={tableConfig.loading.get()}
              isFetchingMoreData={isFetchingMoreData}
              totalData={totalData}
            />
          </div>
        </div>
      ) : null}

      <VuiActionModal show={showActionModal.get()} onHide={() => showActionModal.set(false)} onContinue={tableHandleOnContinue} />
    </>
  );
};

export default PurchaseReceiveItem;
